import type { InfluencerWeb } from '@/plugins/influencer';
import { injectionKeys } from '@/utils/injectionKeys';
import { inject } from 'vue';

export function useInfluencer(): InfluencerWeb {
	const inflcr = inject(injectionKeys.INFLUENCER);
	if (!inflcr) {
		throw new Error('InfluencerWeb not provided');
	}
	return inflcr;
}
